
import Box from '@mui/material/Box';
import { IRapportImageControl } from './RapportMallTypes';
import { SELECTED_SHADOW, getPositionStyle } from './RapportMallUtils';
import { RapportKontrollHeader } from './RapportKontrollHeader';
import { RapporteditorTextField } from '../Rapporteditor/RapporteditorTextField';
import { RapportKontrollEditPosition } from './RapportKontrollEditPosition';
import RapportTypography from './RapportTypography';
import ImageIcon from '@mui/icons-material/Image';

export interface IProps {
  ctrl: IRapportImageControl;
  sx?: any;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onSelect?: (path: number[]) => void;
  onUpdate?: (updatedControl: IRapportImageControl) => void;
  controlPath: number[];
  selected?: boolean;
  maxWidth: number;
  defaultHeight: number;
}

export const RapportImage: React.FC<IProps> = props => {
  const {
    ctrl,
    sx,
    onMouseEnter,
    onMouseLeave,
    selected,
    maxWidth,
    defaultHeight,
  } = props;
  const handleSelect = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    if (props.onSelect) {
      props.onSelect(props.controlPath);
    }
  };
  return (
    <Box
      sx={{
        boxShadow: selected ? SELECTED_SHADOW : undefined,
        border: '1px solid #aaa',
        boxSizing: 'border-box',
        padding: 0,
        ...getPositionStyle(
          ctrl,
          props.controlPath.length > 1,
          maxWidth,
          defaultHeight
        ),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        ...sx,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleSelect}
      data-control-path={props.controlPath.join('-')}
    >
      <RapportTypography
        variant="body2"
        sx={{ marginLeft: 1, marginTop: 0.5 }}
      >{`{${ctrl.Field}}`}</RapportTypography>
      <ImageIcon
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          color: '#80808080',
        }}
      />
    </Box>
  );
};

export interface IRapportImageEditProps {
  value: IRapportImageControl;
  onChange: (ctrl: IRapportImageControl) => void;
}

export const RapportImageEdit: React.FC<IRapportImageEditProps> = props => (
  <Box sx={{ mt: 2 }}>
    <RapportKontrollHeader value={props.value} />
    <RapporteditorTextField
      label="Bildfält"
      field="Field"
      value={props.value}
      onChange={props.onChange}
      allowModelSelect
      selectAttribute
    />
    <RapportKontrollEditPosition
      value={props.value}
      onChange={props.onChange}
    />
  </Box>
);
